/**
 * Loads every product from the allowlisted collections for themed Shop All pages.
 * Liquid seeds the first ~50 products per collection; this fills the rest.
 */
(function () {
  var PAGE_SIZE = 24;

  function money(price) {
    var n = Number(price);
    if (Number.isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function cardHtml(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var image =
      (product.images && product.images[0] && (product.images[0].src || product.images[0])) ||
      (product.featured_image && (product.featured_image.src || product.featured_image)) ||
      '';
    var href = '/products/' + product.handle;
    var title = product.title || '';
    var price = money(variant.price);

    return (
      '<li class="grid__item" data-dm-product-id="' +
      product.id +
      '">' +
      '<a class="dm-js-card" href="' +
      href +
      '">' +
      '<div class="dm-js-card__media">' +
      (image
        ? '<img src="' +
          image +
          '" alt="' +
          title.replace(/"/g, '&quot;') +
          '" loading="lazy" width="600" height="600">'
        : '') +
      '</div>' +
      '<div class="dm-js-card__title">' +
      title +
      '</div>' +
      (price ? '<div class="dm-js-card__price">' + price + '</div>' : '') +
      '</a></li>'
    );
  }

  async function fetchCollectionProducts(handle) {
    var products = [];
    var page = 1;
    while (page <= 40) {
      var url =
        '/collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=250&page=' +
        page;
      var res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) break;
      var data = await res.json();
      var batch = data.products || [];
      if (!batch.length) break;
      products = products.concat(batch);
      if (batch.length < 250) break;
      page += 1;
    }
    return products;
  }

  function pageTokens(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, function (_, index) {
        return index + 1;
      });
    }

    var tokens = [1];
    var start = Math.max(2, current - 1);
    var end = Math.min(total - 1, current + 1);

    if (start > 2) tokens.push('ellipsis');
    for (var page = start; page <= end; page += 1) tokens.push(page);
    if (end < total - 1) tokens.push('ellipsis');
    tokens.push(total);
    return tokens;
  }

  function requestedPage() {
    var params = new URLSearchParams(window.location.search);
    var page = parseInt(params.get('catalog_page') || '1', 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function setPageInUrl(page) {
    var url = new URL(window.location.href);
    if (page === 1) url.searchParams.delete('catalog_page');
    else url.searchParams.set('catalog_page', String(page));
    window.history.replaceState({}, '', url.toString());
  }

  function setupPagination(root, grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item'));
    var pagination = root.querySelector('[data-dm-scoped-pagination]');
    var pagesEl = root.querySelector('[data-dm-pagination-pages]');
    var previous = root.querySelector('[data-dm-page-previous]');
    var next = root.querySelector('[data-dm-page-next]');
    var totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
    var currentPage = Math.min(requestedPage(), totalPages);

    if (!pagination || !pagesEl || !previous || !next) return;

    function render(scrollToGrid) {
      var first = (currentPage - 1) * PAGE_SIZE;
      var last = first + PAGE_SIZE;

      items.forEach(function (item, index) {
        item.hidden = index < first || index >= last;
      });

      pagesEl.innerHTML = '';
      pageTokens(currentPage, totalPages).forEach(function (token) {
        if (token === 'ellipsis') {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'dm-scoped-pagination__ellipsis';
          ellipsis.textContent = '…';
          ellipsis.setAttribute('aria-hidden', 'true');
          pagesEl.appendChild(ellipsis);
          return;
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'dm-scoped-pagination__page';
        button.textContent = String(token);
        button.setAttribute('aria-label', 'Go to catalog page ' + token);
        if (token === currentPage) {
          button.classList.add('is-current');
          button.setAttribute('aria-current', 'page');
        }
        button.addEventListener('click', function () {
          if (currentPage === token) return;
          currentPage = token;
          render(true);
        });
        pagesEl.appendChild(button);
      });

      previous.disabled = currentPage === 1;
      next.disabled = currentPage === totalPages;
      pagination.hidden = totalPages <= 1;
      setPageInUrl(currentPage);

      if (scrollToGrid) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    previous.addEventListener('click', function () {
      if (currentPage <= 1) return;
      currentPage -= 1;
      render(true);
    });
    next.addEventListener('click', function () {
      if (currentPage >= totalPages) return;
      currentPage += 1;
      render(true);
    });

    root.classList.add('is-pagination-ready');
    render(false);
  }

  async function run(root) {
    var handlesEl = root.querySelector('[data-dm-scoped-handles]') || document.querySelector('[data-dm-scoped-handles]');
    var grid = root.querySelector('[data-dm-scoped-grid]');
    var countEl = root.querySelector('[data-dm-scoped-count]');
    var statusEl = root.querySelector('[data-dm-scoped-status]');
    if (!handlesEl || !grid) return;

    var handles = [];
    try {
      handles = JSON.parse(handlesEl.textContent || '[]');
    } catch (e) {
      handles = [];
    }
    if (!handles.length) {
      if (countEl) countEl.textContent = '0 products';
      return;
    }

    var seen = new Set();
    grid.querySelectorAll('[data-dm-product-id]').forEach(function (el) {
      seen.add(String(el.getAttribute('data-dm-product-id')));
    });

    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent = 'Loading more products…';
    }
    if (countEl) {
      countEl.textContent = seen.size + (seen.size === 1 ? ' product' : ' products') + ' (loading…)';
    }

    var appended = 0;
    for (var i = 0; i < handles.length; i++) {
      var handle = handles[i];
      try {
        var products = await fetchCollectionProducts(handle);
        for (var j = 0; j < products.length; j++) {
          var product = products[j];
          var id = String(product.id);
          if (seen.has(id)) continue;
          seen.add(id);
          grid.insertAdjacentHTML('beforeend', cardHtml(product));
          appended += 1;
        }
        if (countEl) {
          countEl.textContent = seen.size + (seen.size === 1 ? ' product' : ' products');
        }
      } catch (err) {
        console.warn('[dm-scoped-catalog] failed for', handle, err);
      }
    }

    if (statusEl) {
      statusEl.hidden = true;
    }
    if (countEl) {
      countEl.textContent = seen.size + (seen.size === 1 ? ' product' : ' products');
    }

    var empty = root.querySelector('[data-dm-scoped-empty]');
    if (empty && seen.size > 0) empty.remove();

    setupPagination(root, grid);
    return appended;
  }

  function init() {
    document.querySelectorAll('[data-dm-scoped-catalog]').forEach(function (root) {
      run(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
